import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Container } from '../../core/models/container.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-container-detail',
  templateUrl: './container-detail.component.html',
  styleUrls: ['./container-detail.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class ContainerDetailComponent implements OnInit {
  @Input() container: Container | null = null; // Recibir el envase
  @Output() closeDetail = new EventEmitter<void>(); // Emitir evento para cerrar el detalle

  constructor() {}

  ngOnInit(): void {}

  close() {
    this.closeDetail.emit(); // Emitir evento de cerrar
  }
}
